var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-background"},[_c('div',{staticClass:"auth-layout"},[_c('router-view')],1),_c('div',{staticClass:"build-number"},[_vm._v(_vm._s(_vm.buildNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }